import React                  from "react";
import PropTypes              from "prop-types";
import CategoriesOverviewGrid from "./CategoriesOverviewGrid";
import Flux                   from '../../flux/Flux';
import SortingSelect          from '../Video/Grid/Filter/SortingSelect';

const SORTING = [Flux.Constants.Vxql.Collection.Order.VIEWS, Flux.Constants.Vxql.Collection.Order.ALPHABETICAL];

class CategoriesOverview extends React.PureComponent {
	constructor(props) {
		super(props);

        this.state = {
            sort: Flux.Constants.Vxql.Collection.Order.VIEWS,
        };

        this.onClickSort = this.onClickSort.bind(this);
	}

    onClickSort(item) {
        this.setState({sort: item});
    }

	render() {
		return (
			<div>
                <SortingSelect sort={this.state.sort}
                    sorting={SORTING}
                    onChange={this.onClickSort}
                    isDisabled={this.props.loading}
                    isMobile={false}
                />
				<CategoriesOverviewGrid sort={this.state.sort} />
			</div>
		);
	}
}

CategoriesOverview.propTypes = {
	data:      PropTypes.array,
	isMobile:  PropTypes.bool,
	loading:   PropTypes.bool,
};


export default CategoriesOverview;